module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-2-3d2269b78fda26c936b6a9f9a44082b3.jpg";